<template>
  <div id="app" style="width: 100%;">
    <div class="pc-page" style="width: 100%; overflow: auto">
      <!-- 顶部banner -->
      <headerBanner></headerBanner>
      <version></version>
      <pros></pros>
      <scene></scene>
      <user></user>
      <footerModule></footerModule>
    </div>
    <div
      class="mobile-page"
      style="width: 100%; height: 100vh; overflow-y: auto"
    >
      <mobileIndex></mobileIndex>
    </div>
    <div class="customer-service" v-drag>
      <img
        class="customer-service-img"
        src="https://qncdn.youinsh.cn/saas_pro/publicFile/image/qn-servicer.jpg"
        alt=""
      />
      <div class="customer-service-text">
        <i class="pc-text">咨</i><i class="pc-text">询</i><i class="pc-text">客</i><i class="pc-text">服</i>
        <span class="mobile-text">咨询客服</span>
      </div>
    </div>

    <!-- <div class="main-content">
    </div> -->
  </div>
</template>

<script>
import headerBanner from "./components/header.vue";
import version from "./components/versionModule.vue";
import pros from "./components/prosModule.vue";
import scene from "./components/sceneModule.vue";
import user from "./components/userModule.vue";
import footerModule from "./components/footerModule.vue";
import mobileIndex from "./components/mobileIndex.vue";

export default {
  name: "App",
  components: {
    headerBanner,
    version,
    pros,
    scene,
    user,
    footerModule,
    mobileIndex,
  },
  created(){
    let name = "bd_vid"
    let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    //匹配目标参数
    let r = window.location.search.substr(1).match(reg);
	//返回参数值
    if(r){
      let expiresDate = new Date();
      expiresDate.setDate(expiresDate.getDate() + 3);
      let host = location.host;
      let domain = ""
      if (host.split('.').length == 1) {
        domain = ".qiniu.com"
      } else {
        let domainParts = host.split('.');
        domainParts.shift();
        domain = '.'+domainParts.join('.');
      }
      console.log("domain======>",domain)
      document.cookie = "bd_logid_url="+window.location+";expires=" + expiresDate.toUTCString() + ";domain=" + domain + ";path=/";
    }
  },
  // 指令的定义
  directives: {
    drag: {
      bind: function (el) {
        console.log("指令的定义", el);
        var left,
          top,
          oW,
          oH,
          sLeft,
          sTop,
          eLeft,
          eTop,
          disX,
          disY,
          dW =
            document.documentElement.clientWidth || document.body.clientWidth,
          dH =
            document.documentElement.clientHeight || document.body.clientHeight;
        function dragStart(e) {
          // 手指触摸屏幕
          //算出手指相对元素左上角的位置
          el.style.transition = "";
          oW = el.offsetWidth;
          oH = el.offsetHeight;
          sLeft = el.offsetLeft;
          sTop = el.offsetTop;
          disX = e.touches[0].clientX - el.offsetLeft;
          disY = e.touches[0].clientY - el.offsetTop;
        }

        function dragMove(e) {
          // 手指滑动
          //用手指的位置减去手指相对元素的位置，得到元素的位置
          left = e.touches[0].clientX - disX;
          top = e.touches[0].clientY - disY;
          if (left <= 0) {
            left = 0;
          } else if (left >= dW - oW) {
            left = dW - oW;
          }
          if (top <= 0) {
            top = 0;
          } else if (top >= dH - oH) {
            top = dH - oH;
          }
          // //移动当前元素
          el.style.left = left + "px";
          el.style.top = top + "px";
        }

        function dragEnd(e) {
          console.log(e);
          // 手指离开屏幕
          if (!left) {
            return;
          }
          left = left >= (dW - oW) / 2 ? dW - oW : 0;
          // //移动当前元素
          el.style.transition = "left 0.3s";
          el.style.left = left + "px";
          el.style.top = top + "px";

          eLeft = el.offsetLeft;
          eTop = el.offsetTop;
          if (
            (eTop - sTop) * (eTop - sTop) + (eLeft - sLeft) * (eLeft - sLeft) <
            10
          ) {
            customerService();
          }

          console.log("www", sLeft, sTop, eLeft, eTop);
          // el.removeEventListener('touchmove', dragMove)
          // el.removeEventListener('touchend', dragEnd)
        }

        el.addEventListener("touchstart", dragStart);
        el.addEventListener("touchmove", dragMove);
        el.addEventListener("touchend", dragEnd);

        // PC 端鼠标事件
        el.onmousedown = function (e) {
          // el.style.cursor = 'move'
          //获取当前鼠标在dom中的位置
          let disx = e.clientX - el.offsetLeft;
          let disy = e.clientY - el.offsetTop;
          let orgiLeft = el.offsetLeft;
          let orgiTop = el.offsetTop;
          document.onmousemove = function (e) {
            //获取移动后当前鼠标距离左边以及上边的距离
            let x = e.clientX - disx;
            let y = e.clientY - disy;
            //获取鼠标在左右、上下所能移动的最大距离
            let maxX =
              document.body.clientWidth -
              parseInt(window.getComputedStyle(el).width);
            let maxY =
              document.body.clientHeight -
              parseInt(window.getComputedStyle(el).height);
            if (x < 0) {
              x = 0;
            } else if (x > maxX) {
              x = maxX;
            }

            if (y < 0) {
              y = 0;
            } else if (y > maxY) {
              y = maxY;
            }

            el.style.left = x + "px";
            el.style.top = y + "px";
          };
          document.onmouseup = function () {
            let after_left = el.offsetLeft;
            let after_top = el.offsetTop;
            // 鼠标抬起时，移动的面积不超过25 触发点击事件
            if (
              (after_top - orgiTop) * (after_top - orgiTop) +
                (after_left - orgiLeft) * (after_left - orgiLeft) <
              25
            ) {
              customerService();
            }
            document.onmousemove = document.onmouseup = null;
          };
        };
        function customerService() {
          if (el.jump) {
            return;
          }
          el.jump = true;
          setTimeout(() => {
            el.jump = false;
          }, 1000);
          let url =
            "https://affim.baidu.com/unique_33857255/chat?siteId=18893624&userId=33857255&siteToken=f4b455a59c12194a23c220b95444331c&cp=&cr=&cw=ent-live-mkt";
          try {
            window.open(url);
          } catch (e) {
            location.href = url;
          }
        }
      },
    },
  },
};
</script>
<style>
#nb_icon_wrap {
  width: 52px !important;
  height: 166px !important;
}
#newBridge .nb-icon-base #nb_icon_inner_wrap {
  background-position: left !important;
}
#newBridge .icon-right-center {
  right: 15px !important;
}
#newBridge .nb-icon-base-5 .nb-icon-inner-wrap {
  background: transparent url("https://www-static.qbox.me/sem/pili-live-1001/source/img/customer-service-staff.png")
    no-repeat !important;
  width: 52px !important;
  height: 166px !important;
  background-size: cover !important;
}
#newBridge .nb-frame-chat-box-right-bottom {
  right: 15px !important;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .pc-page {
    display: none;
  }
  .mobile-page {
    display: block;
  }
  .customer-service {
    display: none;
    width: 1.04rem;
    height: 1.44rem;
    padding: 2px;
    border-radius: 1.04rem 1.04rem .2rem .2rem;
    right: 0.2rem;
    bottom: 4rem;
    .customer-service-text{
      flex-direction: row;
      align-items: center;
      .pc-text{
        display: none;
      }
      .mobile-text{
        font-family: PingFang SC;
        font-size: .24rem;
        line-height: .36rem;
      }
    }
    &-img {
      width: .96rem;
      height: .96rem;
      border-radius: .96rem;
    }
    &-text {
      font-family: PingFang SC;
      font-size: .24rem;
      line-height: .36rem;
    }
  }
}
@media screen and (min-width: 768px) {
  .pc-page {
    display: block;
  }
  .mobile-page {
    display: none;
  }
  .customer-service {
    display: flex;
    width: 52px;
    height: 166px;
    padding: 2px;
    border-radius: 52px;
    right: 10px;
    bottom: 200px;
    .mobile-text{
      display: none;
    }
    &-img {
      width: 48px;
      height: 48px;
      border-radius: 48px;
    }
    &-text {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }
}
.customer-service {
  flex-direction: column;
  align-items: center;
  position: fixed;
  background-size: cover;
  z-index: 999;
  cursor: pointer;
  box-sizing: border-box;
  background: linear-gradient(180deg, #ff3c3a 0%, #ffa35a 100%);
  .customer-service-text{
    padding-top: 9px;
  }
  &-img {
    pointer-events: none;
  }
  &-text {
    font-weight: 400;
    text-align: center;
    color: #ffff;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>